import React from "react";
import MenuItems from "./MenuItems";
import Magazine from "../Global/Magazine";
export default function InsideMenu(props) {
  const Topics = [
    {
      id: "magazine1",
      name: "The Beauty Magazine",
      description: "Luxury Beauty and Style Expert",
      date: "Winter 2018"
    },
    {
      id: "magazine2",
      name: "Allure Magazine",
      description: "Fall Looks, Business of Fake Reviews",
      date: "Fall 2019"
    }
  ];
  const Items = [
    {
      description: "Discover Our New Collection of Skin Products",
      image: "menu-image1"
    },
    {
      description: "Find Your Favorite Eye Product",
      image: "menu-image2"
    }
  ];

  return (
    <>
      {props.mode === "MAKE UP" && (
        <div className="makeup-menu">
          {Items.map((Items, index) => {
            return (
              <MenuItems
                key={index}
                description={Items.description}
                image={Items.image}
              />
            );
          })}
        </div>
      )}
      {props.mode === "Hair" && (
        <div className="hair-menu">
          <div className="hair-menu-txt">
            <b style={{ marginTop: "15px", marginLeft: "15px" }}>
              Deep Conditioning Mask
            </b>
            <b style={{ marginTop: "30px", marginLeft: "15px" }}>Color Care</b>{" "}
            <b style={{ marginTop: "30px", marginLeft: "15px" }}>Shampoo</b>
            <b style={{ marginTop: "30px", marginLeft: "15px" }}>
              Smoothing Conditioner
            </b>
          </div>
          <MenuItems description="Our Other Hair Products" image="hair" />
          <MenuItems description="Our Electric Products" image="Brushing" />
        </div>
      )}
      {props.mode === "BEAUTY MAGAZINE" && (
        <div className="magazine-menu">
          {Topics.map((Topics, index) => {
            return (
              <Magazine
                key={index}
                description={Topics.description}
                id={Topics.id}
                name={Topics.name}
                date={Topics.date}
              />
            );
          })}
        </div>
      )}
      {props.mode === "Other Items" && (
        <div className="makeup-menu">
          <h1>Other Items</h1>
        </div>
      )}
    </>
  );
}
